import React from "react";
import { Navigate, Route } from "react-router-dom";
import Layout from "../components/shared/Layout";
import MachinePage from "../components/machines/MachinePage";
import ServiceReportPage from "../components/serviceReports/ServiceReportPage";
import KioskServiceReportsList from "../components/serviceReports/KioskServiceReportsList";
import CreateServiceReport from "../components/serviceReports/CreateServiceReport";
import SolvingServiceReport from "../components/serviceReports/SolvingServiceReport";
import DocumentsPage from "../components/documents/DocumentsPage";
import KioskDashboard from "../components/kiosk/KioskDashboard";
import KioskSettingsPage from "../components/kiosk/KioskSettingsPage";
import CompanyDetailsPage from "../components/company/CompanyDetailsPage";
import { Roles } from "../../account/models/AccountModels";
import { AuthorizedRoute } from "../../shared/components/Routers";

const usePublicRoutes = () => {
  return (
    <Route path="" element={<AuthorizedRoute role={Roles.ALL_COMPANY_ROLES} />}>
      <Route path="" element={<Layout />}>
        <Route path="machines">
          <Route path=":id" element={<KioskDashboard />}></Route>
          <Route path=":id/details" element={<MachinePage />}></Route>
          <Route path=":id/service-reports/:filter" element={<KioskServiceReportsList />}></Route>
          <Route path=":id/company" element={<CompanyDetailsPage />}></Route>
          <Route path=":id/settings" element={<KioskSettingsPage />}></Route>
        </Route>

        <Route path="service-reports">
          <Route path=":id" element={<ServiceReportPage />}></Route>
          <Route path="create" element={<CreateServiceReport />}></Route>
          <Route path="edit/:id" element={<CreateServiceReport />}></Route>
          <Route path="solving" element={<SolvingServiceReport />}></Route>
        </Route>

        <Route path="documents/:id" element={<DocumentsPage />}></Route>

        <Route path="" element={<Navigate to="machines" />} />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Route>
  );
};

export default usePublicRoutes;
